import React, { useEffect, useMemo, useState } from 'react';
import { Routes, Route } from 'react-router-dom'; // No Router here!
import Dashboard from '../components/Dashboard';
import Header from '../components/Header';
import Footer from '../components/Footer';
import styled from 'styled-components';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';
import Services from '../components/Services';
import AboutUs from '../components/AboutUs';
import Blogs from '../components/Blogs/Blogs';
import BlogReadMore from '../components/Blogs/BlogReadMore';
import ContactUsForm from '../components/ContactUs';
import GetInTouch from '../components/GetinTouch';
import DataScienceAi from '../components/Services/DataScienceAi';
import DataEngineering from '../components/Services/DataEngineering';
import CodeMasters from '../components/Services/CodeMasters';
import BusinessIntelligence from '../components/Services/BI';
import DigitalMarketing from '../components/Services/DigitalMarketing';
import TalentAcquisition from '../components/Services/Talent';

const ParticlesWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
`;

const AppRoutes = () => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesOptions = useMemo(() => ({
    background: { color: { value: "#ffffff" } },
    fpsLimit: 120,
    interactivity: {
      events: {
        onClick: { enable: true, mode: "push" },
        onHover: { enable: true, mode: "repulse" },
      },
      modes: {
        push: { quantity: 4 },
        repulse: { distance: 200, duration: 0.4 },
      },
    },
    particles: {
      color: { value: "#000000" },
      links: {
        color: "#000000",
        distance: 150,
        enable: true,
        opacity: 0.5,
        width: 2,
      },
      move: {
        enable: true,
        speed: 2,
        outModes: { default: "bounce" },
      },
      number: {
        density: { enable: true },
        value: 80,
      },
      opacity: { value: 0.2 },
      shape: { type: "circle" },
      size: {
        value: { min: 2, max: 2 },
        animation: {
          enable: false, // Disable size animation
        },
      },
    },
    detectRetina: true,
  }), []);
  

  return (
    <>
      <Header />
      {init && (
        <ParticlesWrapper>
          <Particles id="tsparticles" options={particlesOptions} />
        </ParticlesWrapper>
      )}

      {/* Routes from react-router-dom v6 */}
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog/:id" element={<BlogReadMore />} />


        <Route path="/services/data-science-ai" element={<DataScienceAi />} />
    <Route path="/services/data-engineering" element={<DataEngineering />} />
    <Route path="/services/code-masters" element={<CodeMasters />} />
    <Route path="/services/business-intelligence" element={<BusinessIntelligence />} />
    <Route path="/services/digital-marketing" element={<DigitalMarketing />} />
    <Route path="/services/talent-acquisition" element={<TalentAcquisition />} />

      </Routes>

      {/* Contact Form */}
      
      <div style={{ maxWidth: 1200, margin: '0 auto', textAlign: 'center', padding: '0 40px' }}>
      <GetInTouch/>
        <ContactUsForm />
      </div>

      <Footer />
    </>
  );
};

export default AppRoutes;
